export default "__VITE_ASSET__Qvw9MzYq__"